const { I18n, getCurrentUser, getExternalUser, APP_CONSTANTS, AppState, $ } = window;

export { I18n, getCurrentUser, getExternalUser, APP_CONSTANTS, AppState, $ };
